import { CloseIcon } from '@mm/icons';
import { selectCurrentUser } from '@mm/state/selectors/userSelector';
import React from 'react';
import { useSelector } from 'react-redux';
import { VerificationForm } from '../../../modules/LoginRouter/components/VerificationForm/VerificationForm';
import { CloseModalProps } from '../modal-helpers';
import dataprotectionIcon from './dataprotection.svg';
import styles from './VerifyEmailModal.module.css';

export const VerifyEmailModal = (props: CloseModalProps) => {
  const { closeModal } = props;
  const { email = '' } = useSelector(selectCurrentUser) || {};

  return (
    <div className={styles.container}>
      <CloseIcon
        className={styles.closeIcon}
        onClick={closeModal}
        color="#262626"
      />
      <img src={dataprotectionIcon} className={styles.logo} />
      <div className={styles.heading}>We need to verify your email</div>
      <div className={styles.description}>
        We sent an email to the following address{' '}
        <span className={styles.email}>{email}</span>
      </div>
      <div className={styles.description}>
        Check your email to get your verification code. You may need to check
        your spam folder.
      </div>
      <VerificationForm
        inputsOnly
        stylings={{
          card: styles.verifyFormCard,
          verifyButtonsContainer: styles.verifyButtonsContainer,
          resendContainer: styles.resendContainer,
          primaryButton: styles.resendButton,
          paragraph: styles.paragraph,
        }}
      />
    </div>
  );
};
